import { createContext, useContext, ReactNode } from 'react';

interface DashboardContextType {
  showSearch: boolean;
  setShowSearch: (show: boolean) => void;
  showNotifications: boolean;
  setShowNotifications: (show: boolean) => void;
  showUserMenu: boolean;
  setShowUserMenu: (show: boolean) => void;
  showSettings: boolean;
  setShowSettings: (show: boolean) => void;
  markNotificationsAsRead: () => void;
  generateNotifications: () => any[];
  readNotifications: Set<string>;
}

const DashboardContext = createContext<DashboardContextType | null>(null);

export function useDashboard() {
  const context = useContext(DashboardContext);
  return context;
}

export function DashboardProvider({ children, value }: { children: ReactNode; value: DashboardContextType }) {
  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}
